// @ts-nocheck
import React, { useState } from 'react';
import { ButtonUI, MultipleTagSelector } from 'sonata-react-components';

import { ReportingInsightsItemsSelectionModal } from '@/modules/reporting/ReportingInsights/ReportingInsightsItemsSelectionModal';
import { InsightsItemsSelectorStyled } from './InsightsItemsSelector.styled';

export type ItemsByFamily = Record<string, string[]>;

type Props = {
  className: string;
  id: string;
  items: {
    label: string;
    value: string;
  }[];
  onChangeToggled: (newItemsSelection: string[], isAllSelected?: boolean) => void;
  selectedFamilyItems: string[];
  settingsModalButton?: {
    className: string;
    enabled: boolean;
    onItemsSelectionModalToggled: (newItemsByFamily: ItemsByFamily) => void;
    selectedItemsByFamily: ItemsByFamily;
  };
};

type State = {
  showItemsSelectionModal: boolean;
};

function InsightsItemsSelector({
  className,
  id,
  items,
  onChangeToggled,
  selectedFamilyItems,
  settingsModalButton
}: Props) {
  const [{ showItemsSelectionModal }, setState] = useState<State>({
    showItemsSelectionModal: false
  });

  return (
    <InsightsItemsSelectorStyled className={className} id={id}>
      <MultipleTagSelector
        items={items}
        mark
        onChange={newItemsFamilies => onChangeToggled(newItemsFamilies, true)}
        selectedItems={selectedFamilyItems}
        textColor="simpleSelectorTagText"
      />
      {settingsModalButton?.enabled && (
        <>
          <ButtonUI
            className={settingsModalButton?.className}
            icon="fa fa-sliders"
            onClick={() =>
              setState(prevState => ({
                ...prevState,
                showItemsSelectionModal: true
              }))
            }
            shape="link"
            size="ultraSmall"
            type="secondary"
            visible
          />
          <ReportingInsightsItemsSelectionModal
            filterCategories={items}
            isModalOpened={showItemsSelectionModal}
            onClose={() =>
              setState(prevState => ({
                ...prevState,
                showItemsSelectionModal: false
              }))
            }
            onSave={selectedValues => {
              setState(prevState => ({
                ...prevState,
                showItemsSelectionModal: false
              }));
              settingsModalButton.onItemsSelectionModalToggled(selectedValues);
            }}
            value={settingsModalButton.selectedItemsByFamily}
          />
        </>
      )}
    </InsightsItemsSelectorStyled>
  );
}

export default InsightsItemsSelector;
